<template lang='pug'>
  .page-menu(v-scroll='onScroll' ref='menu'
    :class="{'menu-hidden': menuHidden, opened: menuOpened}")
    slot(name="before")
    div(v-for="(block,i) in elements" :class="`menu__${blockNames[i]}`" v-if="i === 1 ? menuOpened : true")
      template(v-for="el in block")
        div(:is="el.type" :class="[`${blockNames[i]}__${el.name}`, `menu__${el.name}`, classes[el.fullName],\
          el.num ? `${el.name}_${el.num}` : false, \
           {changed: isChangedButton(el), opened: isChangedButton(el) && menuOpened}]"
          v-bind="{...el.props,...data[el.fullName]}"
          v-if="data[el.fullName] && data[el.fullName].visible!== undefined ? data[el.fullName].visible : true"
          :click="el.name === 'button' || (el.type === 'linker' && menuOpened) ? toggleMenu : null")
          slot(:name='el.fullName' v-if="el.name !== 'items'" :[el.fullName]="data[el.fullName]")
          template(v-for='(item,j) in items'  v-else)
            pass(:a_item="getItem(item,j,i === 1)" v-slot="{a_item}")
              slot(:name='el.fullName' :item="getItem(item)")
                linker.items__item(:goalName="_getItemGoal(j)" v-bind="a_item"
                  :class="getItemClass(item,j,i)"
                  @click.native="menuOpened ? toggleMenu() : false")
    slot(name="after")
</template>

<script>
  import {ref,computed} from '@vue/composition-api'
  import linker from "./linker.vue";
  import share from "./share.vue";
  import {mobile_mixin, toggleRef} from "@/base/utils"

  export default {
    name: "MainMenu",
    props: {
      //base
      items: {type: Array, default: () => ([])},
      data: {type: Object, default: () => ({})},
      getItem:{type: Function, default: (item,j,open) => item},
      classes: {type: Object, default: () => ({})},
      getItemClass:{type: Function, default: (item,j,open) => ''},
      //lines
      line: {type: String, default: 'l1_i_l2'},
      open: {type: String, default: ''},
      //scroll
      hideOnScroll: {type: Function, default: () => true},
      scrollFunc: {type: Function, default: null},
      //goal
      itemsGoal: {type: String, default: 'menu_'},
      getItemGoal: {type: Function, default: null}
    },
    components: {linker,share},
    mixins: [mobile_mixin],

    setup(props,{slots}) {

      const blockNames = ref(['line','open']);
      const blockTypes = {
        i: {name:'items'},
        l: {name:'logo', type: 'linker'},
        b: {name:'button', type: 'linker', props:{img:'img/common/menu_button.svg'}},
        s: {name:'sharing', type: 'share'},
        a: {name:'add'}
      };

      const elements = computed(() => {
        const els = [[],[]];
        const blocks = [props.line ? props.line.split('_') : [],
          props.open? props.open.split('_') : [], ];
        for (let i = 0; i < blocks.length; i++) {
          const block = blocks[i];
          for (let j = 0; j < block.length; j++) {
            const [short,num=''] = (block[j].match(/(\D+)(\d+)?/)).slice(1);
            const add = i ? 'o_' : '';
            const elType = blockTypes[short];
            els[i].push({short: short, num: num, name: elType.name,
              fullName: add+elType.name+num, type: elType.type ? elType.type : 'div', props: elType.props});
          }
        }
        return els;
      });

      const menu = ref(null);
      const menuOpened = ref(false);
      const menuHidden = ref(false);

      const onScroll = (e, options) => {
        if (!menuOpened.value && props.scrollFunc) props.scrollFunc(e,options);
        if (menuOpened.value || !props.hideOnScroll()) return;
        let menuHeight = menu.value.clientHeight;
        menuHidden.value = options.scrollTop > options.lastScrollTop && options.scrollTop > menuHeight;
      };

      let saveBodyOverflow;
      const bodyStyle = document.body.style;
      const toggleMenu = () => {
        if (menuOpened.value) bodyStyle.overflow = saveBodyOverflow; else {
          saveBodyOverflow = bodyStyle.overflow;
          bodyStyle.overflow = 'hidden'
        }
        toggleRef(menuOpened);
      };

      const existSlot = name => {
        //console.log(name, props[name], slots[name]);
        console.log(name);
        return (slots[name] !== undefined)
      };

      const isChangedButton = (el) => {
        return el.short === 'b' && props.data[el.fullName]
          && Array.isArray(props.data[el.fullName].img)
      };

      const _getItemGoal = (num) => props.getItemGoal ? props.getItemGoal(num)
        : props.itemsGoal ? `${props.itemsGoal}${num+1}` : '';

      return {
        elements,
        blockNames,
        blockTypes,

        existSlot,

        menu,
        toggleMenu,
        menuOpened,
        menuHidden,
        onScroll,

        isChangedButton,

        _getItemGoal
      }

    }
  }
</script>

<style lang='stylus'>
  @import "../base/mixins.styl"
  .page-menu
    position: fixed;
    width: 100%
    transition all .3s
    &.menu-hidden
      transform translateY(-100%)
    .menu__line
      position: relative;
      z-index: 101
      display: flex;
      align-items: center;
      justify-content: space-between;
    .menu__items
      display: flex;
      .items__item
        margin: 0 1rem
    .menu__logo
      width: 10rem
    .menu__button
      width: 8rem
      cursor: pointer;
      &.changed
        .linker__image
          choose_child(1)
        &.opened
          .linker__image
            choose_child(2)
    .menu__open
      position: absolute;
      top: 0
      left: 0
      width: 100%
      height: 100vh
      z-index: 100
      display: flex;
      flex-direction: column;
      justify-content: center;
      .menu__items
        flex-direction: column;
        align-items: center;
        .items__item
          margin: 1rem auto
</style>